import Layout from "@/components/feature/Layout";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import Strengths from "@/pages/home/components/Strengths";
import ServicesPreview from "@/pages/home/components/ServicesPreview";
import AboutPreview from "@/pages/home/components/AboutPreview";
import CasesPreview from "@/pages/home/components/CasesPreview";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaBanner from "@/pages/home/components/CtaBanner";

export default function Home() {
  return (
    <Layout>
      <Hero />
      <TrustBar />
      <Strengths />
      <ServicesPreview />
      <AboutPreview />
      <CasesPreview />
      <FaqPreview />
      <CtaBanner />
    </Layout>
  );
}